export default {
  key: 'AIzaSyDajI6qq4kDumud1uutvxBMTCJB-ZS6SW8',
  language: 'pt-BR',
  region: 'br',
}